import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { helper } from 'src/environments/helper';
import { ConfiguratorModuleService } from '../configurator-module.service';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import {
  ConfiguratorModuleAddPayload,
  ConfiguratorModuleEditPayload,
} from '../configuratorModule.interface';
import { Observable, finalize } from 'rxjs';
import { ModulesService } from '../../modules/modules.service';
import { ModuleGroupPermissionService } from '../../module-group-permission/module-group-permission.service';
import { ModulePermissionService } from '../../module-permission/module-permission.service';
import { Generic } from 'src/app/interfaces/generic.interface';

@Component({
  selector: 'app-edit-configurator-module',
  templateUrl: './edit-configurator-module.component.html',
  styleUrls: ['./edit-configurator-module.component.scss'],
})
export class EditConfiguratorModuleComponent implements OnInit {
  // general error
  errorTitle: string = helper.dialogConfig.headers.errorAtentie;
  errorIcon: string = helper.dialogConfig.icons.error;
  errorType: string = helper.dialogConfig.icons.error;
  helper = helper;

  modules$!: Observable<Generic[]>;
  groupModules$!: Observable<Generic[]>;
  permissionsModules$!: Observable<Generic[]>;

  token!: string;
  isLoading = false;
  form: FormGroup = new FormGroup({
    module_id: new FormControl(this.data.module_id, [Validators.required]),
    group_id: new FormControl(this.data.group_id, [Validators.required]),
    permission_id: new FormControl(this.data.permission_id, [
      Validators.required,
    ]),
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<EditConfiguratorModuleComponent>,
    private configModuleService: ConfiguratorModuleService,
    private notificationService: NotificationService,
    private authService: AuthService,
    public modulesService: ModulesService,
    public moduleGroupPermissionService: ModuleGroupPermissionService,
    public modulePermissionService: ModulePermissionService,
  ) {
    this.processToken();
  }

  ngOnInit(): void {
    this.loadModules();
    this.loadGroups();
    this.loadPermissions();
  }

  loadModules() {
    this.isLoading = true;
    this.modules$ = this.modulesService
        .getModules()
        .pipe(finalize(() => (this.isLoading = false)));
  }
  loadGroups() {
    this.isLoading = true;
    this.groupModules$ = this.moduleGroupPermissionService
        .getModules()
        .pipe(finalize(() => (this.isLoading = false)));
  }
  loadPermissions() {
    this.isLoading = true;
    this.permissionsModules$ = this.modulePermissionService
        .getModules()
        .pipe(finalize(() => (this.isLoading = false)));
  }

  closeDialog() {
    this.dialogRef?.close({
      success: false,
    });
  }

  processToken() {
    const tokenObj = this.authService.returnTokenUser();
    tokenObj.then((token) => {
      this.token = token;
      this.configModuleService.setToken(token);
    });
  }

  submitForm() {
    this.isLoading = true;

    const { module_id, group_id, permission_id } = this.form
      .value as ConfiguratorModuleAddPayload;
    const updateConfig: ConfiguratorModuleEditPayload = {
      id: this.data.id,
      module_id,
      group_id,
      permission_id,
    };

    this.configModuleService
      .updateGroupPermission(updateConfig)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: () => {
          this.dialogRef.close({ success: true });
        },
        error: (err) => {
          let msg;
          try {
            // try to catch the message from server
            msg = err.error.errors.message[0];
          } catch (error) {
            // controll output message
            msg = helper.dialogConfig.generalMessages.error;
          }
          this.notificationService.warningSwal(
            helper.dialogConfig.headers.errorAtentie,
            msg,
            this.errorIcon
          );
        },
      });
  }

  onHttpError(res: any) {
    if (res.errors && res.errors.message && res.errors.message.length > 0) {
      res.errors.message.forEach((msg: string) => {
        this.notificationService.warningSwal(
          this.errorTitle,
          msg,
          this.errorIcon
        );
      });
    } else {
      let msg;
      try {
        // try to catch the message from server
        msg = res.error.errors.message[0];
      } catch (error) {
        // controll output message
        msg = helper.dialogConfig.generalMessages.error;
      }
      this.notificationService.warningSwal(
        this.errorTitle,
        msg,
        this.errorIcon
      );
    }
  }
}
